(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instant-product-groups"] && !Shopify.designMode) return;
  try {
    
  const initializeInstantGroups = (scope = document) => {
    scope.querySelectorAll('[data-instant-group]').forEach((group) => {
      if (group.dataset.paginationReady === 'true') return;

      const cards = Array.from(group.querySelectorAll('[data-instant-card]'));
      const navigation = group.querySelector('[data-instant-nav]');
      const previous = group.querySelector('[data-instant-prev]');
      const next = group.querySelector('[data-instant-next]');
      const pageLabel = group.querySelector('[data-instant-page]');
      const desktop = window.matchMedia('(min-width: 700px)');
      const pageSize = 3;
      const pageCount = Math.max(1, Math.ceil(cards.length / pageSize));
      let currentPage = 0;

      const render = () => {
        cards.forEach((card, index) => {
          card.hidden = desktop.matches && (index < currentPage * pageSize || index >= (currentPage + 1) * pageSize);
        });

        navigation.hidden = !desktop.matches || pageCount <= 1;
        previous.disabled = currentPage === 0;
        next.disabled = currentPage >= pageCount - 1;
        pageLabel.textContent = `${currentPage + 1} / ${pageCount}`;
      };

      const setPage = (newPage) => {
        const update = () => {
          currentPage = newPage;
          render();
        };

        if (document.startViewTransition) {
          document.startViewTransition(update);
        } else {
          update();
        }
      };

      previous.addEventListener('click', () => {
        if (currentPage > 0) setPage(currentPage - 1);
      });

      next.addEventListener('click', () => {
        if (currentPage < pageCount - 1) setPage(currentPage + 1);
      });

      desktop.addEventListener('change', () => {
        currentPage = 0;
        render();
      });

      group.dataset.paginationReady = 'true';
      render();
    });
  };

  initializeInstantGroups();

  document.addEventListener('shopify:section:load', (event) => {
    initializeInstantGroups(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
